import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const atosTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#0180fe',
      },
      secondary: {
        main: '#06186f',
      },
      error: {
        main: '#0089d1',
      },
      warning: {
        main: '#718dc9',
      },
      info: {
        main: '#34548a',
      },
      success: {
        main: '#0765fe',
      },
      background: {
        default: '#f2f2f2',
        paper: '#ffffff',
      },
      banner: {
        info: '#34548a',
        error: '#0089d1',
        text: '#0180fe',
        link: '#06186f',
      },
      errorBackground: '#0099e9',
      warningBackground: '#0099e9',
      infoBackground: '#0180fe',
      navigation: {
        background: '#0180fe',
        indicator: '#5c5c5c',
        color: '#d5d6db',
        selectedColor: '#ffffff',
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: 'Arial',

  /* below drives the header colors */
  pageTheme: {
    home: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({
      colors: ['#0180fe', '#06186f'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#0099e9', '#0180fe'],
      shape: shapes.wave,
    }),
  },
});
